module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.fb650aaf.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.ttf
// module id = 2530
// module chunks = 7